import { configureStore } from "@reduxjs/toolkit";
import setAuthToken from "./untils/setAuthToken";
import authReducer from "./reducers/authReducer";
import loadingReducer from "./reducers/loadingReducer";
import bidReducer from "./reducers/bidReducer";
import themeReducer from "./reducers/themeReducer";
import timezoneReducer from "./reducers/timezoneReducer";
import permissionsReducer from "./reducers/permissionsReducer";

const store = configureStore({
  reducer: {
    auth: authReducer,
    loading: loadingReducer,
    bid: bidReducer,
    themeMode: themeReducer,
    timezoneMode: timezoneReducer,
    permissions: permissionsReducer,
  },
  // Never expose application state/actions to the Redux DevTools extension.
  devTools: false,
  // You can add middleware here if needed, but thunk is included by default
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

let currentState = store.getState();

store.subscribe(() => {
  let previousState = currentState;
  currentState = store.getState();

  if (previousState.auth.token !== currentState.auth.token) {
    const token = currentState.auth.token;
    setAuthToken(token);
  }
});

export default store;
